import { css } from 'lit';
export const cardStyles = css `
    .hlx-card {
        display: flex;
        flex-direction: column;
        background-color: var(--hlx-color-neutral-0);
        border: 0.5px solid var(--hlx-color-neutral-30);
        border-radius: var(--hlx-radius-sm);
    }

    .hlx-card-image {
        display: flex;
        border-top-left-radius: var(--hlx-radius-sm);
        border-top-right-radius: var(--hlx-radius-sm);
        margin: calc(-1 * 0.5px);
        overflow: hidden;
    }

    .hlx-card-image::slotted(img) {
        display: block;
        width: 100%;
    }

    .hlx-card:not(.hlx-card-has-image) .hlx-card-image {
        display: none;
    }

    .hlx-card-header {
        display: block;
        border-bottom: 0.5px solid var(--hlx-color-neutral-30);
        padding: var(--hlx-spacing-lg);
    }
    @media (min-width: 992px) {
        .hlx-card-header {
            padding: var(--hlx-spacing-2xl);
        }
    }

    .hlx-card:not(.hlx-card-has-header) .hlx-card-header {
        display: none;
    }

    .hlx-card:not(.hlx-card-has-image) .hlx-card-header {
        border-top-left-radius: var(--hlx-radius-sm);
        border-top-right-radius: var(--hlx-radius-sm);
    }

    .hlx-card-body {
        display: block;
        padding: var(--hlx-spacing-lg);
    }
    @media (min-width: 992px) {
        .hlx-card-body {
            padding: var(--hlx-spacing-2xl);
        }
    }

    .hlx-card-has-footer .hlx-card-footer {
        display: block;
        border-top: 0.5px solid var(--hlx-color-neutral-30);
        padding: var(--hlx-spacing-lg);
    }
    @media (min-width: 992px) {
        .hlx-card-has-footer .hlx-card-footer {
            padding: var(--hlx-spacing-2xl);
        }
    }

    .hlx-card:not(.hlx-card-has-footer) .hlx-card-footer {
        display: none;
    }
`;
//# sourceMappingURL=card.styles.js.map